import { Form, Input } from 'antd'
import useSettingTourLocation from 'pages/building/tourViewerPage/hook/useSettingTourLocation'
import Validators from 'utils/validators'

import Button from 'components/atoms/Button'
import Modal from 'components/atoms/Modal'
import Spinner from 'components/atoms/Spinner'
import Title from 'components/atoms/Title'

type Props = {
  handleCancel: () => void
}

export default function ModalSettingTourLocation({ handleCancel }: Props) {
  const {
    handleSaveMap,
    handleDeleteTourLocation,
    form,
    isValidSharedLink,
    locationUrlValue,
    updating,
    isLoading,
    deleting,
    isUploading,
    t
  } = useSettingTourLocation({ handleCancel })

  return (
    <Modal className="modal-custom" width={700}>
      <Title title={t('building.mapSetting.title')} bottomMargin="mb-[31px]" />
      <Spinner spinning={updating || isLoading || deleting || isUploading}>
        <Form form={form} colon={false} onFinish={handleSaveMap}>
          {/* Map url */}
          <Form.Item
            name="locationUrl"
            className="input-floor thin-error-message"
            label={t('building.mapSetting.googleMapUrl')}
            rules={[
              {
                validator: Validators.urlValidatorForIframeGoogleMap(t)
              }
            ]}
          >
            <Input
              className="w-full h-[38px] text-[14px] font-[400]"
              placeholder={t('building.mapSetting.googleMapUrl_PlaceHolder')}
            />
          </Form.Item>

          {/* Frame map */}
          <div className="flex justify-center items-center pb-4">
            <iframe
              src={String(locationUrlValue)?.match(/src="([^"]+)"/)?.[1] || ''}
              className="w-[450px] h-[274px]"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map"
            />
          </div>
          {/* url for open new tab */}
          {locationUrlValue && (
            <div
              className="underline text-center text-blue-500 cursor-pointer"
              onClick={() => {
                window.open(
                  String(locationUrlValue)?.match(/src="([^"]+)"/)?.[1] || '',
                  '_blank'
                )
              }}
            >
              {t('building.mapSetting.openMap')}
            </div>
          )}

          {/* Action area */}
          <div className="flex gap-10 justify-center mt-10">
            {/* Button delete */}
            <Button
              onClick={handleDeleteTourLocation}
              sizing="w-[140px] h-[50px]"
              className="bg-[#B80808]"
            >
              {t('common.delete')}
            </Button>
            {/* Button cancel */}
            <Button sizing="w-[140px] h-[50px]" onClick={handleCancel}>
              {t('building.buttonCancel')}
            </Button>
            {/* Button save */}
            <Button
              htmlType="submit"
              type="primary"
              sizing="w-[140px] h-[50px]"
              disabled={!isValidSharedLink || locationUrlValue?.trim() === ''}
            >
              {t('building.buttonSave')}
            </Button>
          </div>
        </Form>
      </Spinner>
    </Modal>
  )
}
